export default __webpack_public_path__ + "static/media/delete-icon.10ae4811.svg";